module.exports = __webpack_public_path__ + "img/csr3.ca296369.png";